/* eslint-disable eag/match-named-export */
import {createContext} from 'shared/web';

import {FiltersType} from '../../types/FiltersType';

export type UpdateFiltersFunction = <K extends keyof FiltersType>(
  key: K,
  value: FiltersType[K] | ((current: FiltersType[K] | undefined) => FiltersType[K])
) => void;

interface FiltersContext {
  filters: FiltersType;
  /**
   * Pre-computed derived boolean — true when at least one filter differs from
   * the default. Consumers that only need this boolean should read it directly
   * from context instead of subscribing to the full `filters` object, so they
   * only re-render on actual boolean transitions (rule: rerender-derived-state).
   */
  hasFilters: boolean;
  onChange: (filters: FiltersType) => void;
  onUpdateFilters: UpdateFiltersFunction;
  onClearFilters: () => void;
}

export const [FiltersContextProvider, useFilters] = createContext<FiltersContext>();
